import { render, staticRenderFns } from "./PermissionForm.vue?vue&type=template&id=06a9831f&"
import script from "./PermissionForm.vue?vue&type=script&lang=js&"
export * from "./PermissionForm.vue?vue&type=script&lang=js&"
import style0 from "./PermissionForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PermissionForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports